import { Injectable } from '@angular/core';
import { DataPrivacyFastTrackRepoService } from '@client/app/modules/data-privacy/services/api/data-privacy-fast-track-repo/fast-track-repo.service';

@Injectable({
    providedIn: 'root',
})
export class DataPrivacyEntitiesFastTrackService {

    constructor (
        private dataPrivacyFastTrackRepoService: DataPrivacyFastTrackRepoService,
    ) { }

    /**
     * Get Fast Track Content Data
     * @param params - Query Parameters
     * @param config - $http provider configuration
     */
    getAll (params?: any, config?: any): Promise<any[]> {
        return this.dataPrivacyFastTrackRepoService.getAll(params);
    }

    /**
     * Get Fast Track Content Data
     * @param dpContentId - The Data Privacy Content ID
     * @param params - Query Parameters
     * @param config - $http provider configuration
     */
    get (dpContentId: string, params?: any, config?: any): Promise<any> {
        return this.dataPrivacyFastTrackRepoService.get(dpContentId, params);
    }

    /**
     * Get Fast Track Content Data
     * @param dpContentId - The Data Privacy Content ID
     * @param params - Query Parameters
     * @param config - $http provider configuration
     */
    getInfoTypes (dpContentId: string, params?: any, config?: any): Promise<any[]> {
        return this.dataPrivacyFastTrackRepoService.getInfoTypes(dpContentId, params);
    }

    /**
     * Update Fast Track Info Type
     * @param dpContentId - The Data Privacy Content ID
     * @param infoType - The Data Privacy Info Type
     * @param params - Query Parameters
     * @param config - $http provider configuration
     */
    updateInfoType (dpContentId: string, infoType: any, params?: any, config?: any): Promise<any> {
        return this.dataPrivacyFastTrackRepoService.updateInfoType(dpContentId, infoType, params);
    }
}
